import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Stack } from '@mui/material';
import TopNavBar from '../../Components/TopNavigation/TopNavBar';
import { request } from '../../Utils/request';
import DiscoveredPlaceListItem from './DiscoveredPlaceListItem';

type Place = {
  _id: string;
  name: string;
  categories: string[];
  tags: string[];
  files?: Array<{ fileURL: string }>;
  status?: 'approved' | 'pending' | string;
  approvalStatus?: 'approved' | 'pending' | string;
  isApproved?: boolean;
};

const MyPlaces: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [places, setPlaces] = useState<Place[]>([]);

  useEffect(() => {
    setLoading(true);
    request<{ success: boolean; data: Place[] }>('/places/my-places', { authorization: true })
      .then((res) => {
        if (res?.success && Array.isArray(res?.data)) {
          setPlaces(res.data);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch my places', err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
      <TopNavBar title="Discovered places" canGoBack />

      <Box sx={{ px: 2, pb: 3 }}>
        {loading ? (
          <Stack alignItems="center" justifyContent="center" sx={{ mt: 4 }}>
            <CircularProgress size={28} />
          </Stack>
        ) : places.length === 0 ? (
          <Typography sx={{ mt: 3 }} color="text.secondary">
            No discovered places yet.
          </Typography>
        ) : (
          <Stack spacing={2} sx={{ mt: 1 }}>
            {places.map((place) => {
              const imageUrl = place?.files?.[0]?.fileURL || '';
              const derivedStatus = typeof place.isApproved === 'boolean'
                ? (place.isApproved ? 'approved' : 'pending')
                : (place.status || place.approvalStatus || 'pending');
              return (
                <DiscoveredPlaceListItem
                  key={place._id}
                  id={place._id}
                  imageUrl={imageUrl}
                  title={place.name}
                  categories={place.categories}
                  tags={place.tags}
                  status={derivedStatus as any}
                  rating={0}
                />
              );
            })}
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default MyPlaces;


